module.exports = __webpack_public_path__ + "static/language-002117f47c43b3f97a04c0718bbb52e5.png";